const form = {
  formFieldWrap: {
    clearFieldBtn: 'Clear',
  },
};

export default form;
